import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiEndpoints } from '../../http/api-endpoints';
import { ApiModule, ModuleEnum } from '../../decorators/api-module.decorator';
import { JulContextLibService } from 'jul-web-shared-lib/src/lib/components/context';

@Injectable({
  providedIn: 'root'
})

@ApiModule(ModuleEnum.GAD)
export class DeputyService {

  constructor(private http: HttpClient, private julContextService: JulContextLibService) { }


  get(userId: string): Observable<any> {
    this.julContextService.setContextNational();
    return this.http.get<any>(ApiEndpoints.core.deputy.get(userId)).pipe(
      map((response: any) => <any>response.data)
    );
  }

  getPossibleSubstitutes():any {
    this.julContextService.setContextNational();
    return this.http.get(ApiEndpoints.core.deputy.getPossibleSubstitutes()).pipe(
      map((response: any) => <any>response.data)
    );
  }



}

